import {
    Backdrop, Button, CircularProgress, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText, Grid
} from '@material-ui/core'
import { AccessTime, Cached } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useAuth } from "../../hooks/auth"
import MvmApi from '../../services/MvmApi'
import DataGrid from './components/DataGrid'
import ShedMonitor from './components/ShedMonitor'
import { useStyles } from './Style'

type SelectedIdAndType = {
    id: string;
    description: string;
    code: string;
    type: string;
}

const MonitoringPanel: React.FC = () => {
    const classes = useStyles()
    const { t: _t } = useTranslation("General")
    const history = useHistory()
    const [selectedOnSideMenu, setSelectedOnSideMenu] = React.useState<SelectedIdAndType>({id: '', description: '', code: '', type: ''});
    const [sideMenu, setSideMenu] = useState<any>(null)
    const { user } = useAuth()
    const [circularLoading, setCircularLoading] = useState(false)
    const [refetch, setRefetch] = useState<boolean>(false) 

    useEffect(() => {
        setCircularLoading(true)
        MvmApi.getMonitoringPanelMenu(user.company.plantID)
            .then((response) => {
                setSideMenu(response)
            })
            .finally(() => setCircularLoading(false))

    }, [refetch])

    return (
        <Dialog
            classes={{ paper: classes.dialog}}
            open={true}
            fullWidth
            maxWidth="lg"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogContent style={{width: '100%!important', maxWidth: '100%!important'}}>
                <DialogContentText id="alert-dialog-description">
                    <Grid container spacing={2}>
                        <Grid container xs={3} style={{width: '100%'}}>
                            <Grid item 
                                onClick={() => setRefetch(!refetch) }
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background:'rgba(70,130,180, 1)', 
                                    fontSize: 26,
                                    margin: 3,
                                    width: '48%',
                                    cursor: 'pointer',
                                    height: 102,
                                    color: 'white'
                                }}>
                                <Cached style={{fontSize: 40, marginRight: 6}}/>
                                <span>Atualizar</span>
                            </Grid>
                            <Grid item 
                                onClick={() => {setSelectedOnSideMenu({id: '0', description: "OverTime", code: "", type: 'OVERTIME'})}}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'rgba(70,130,180, 1)', 
                                    fontSize: 26,
                                    margin: 3,
                                    width: '48%',
                                    cursor: 'pointer',
                                    height: 102,
                                    color: 'white'
                                }}>
                                <AccessTime style={{fontSize: 40, marginRight: 6}}/>
                                <span>Overtime</span>
                            </Grid>
                            <p style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                                <AccessTime style={{marginRight: 4}}/> Atualizado às {new Date().toLocaleString()}
                            </p>
                           

                            {sideMenu ? 
                                sideMenu.concierges.map((element: any) => {
                                    return(
                                        <ShedMonitor 
                                            selectedIdAndType={{id: selectedOnSideMenu.id, type: selectedOnSideMenu.type}}
                                            onClick={() => {setSelectedOnSideMenu({id: element.id, description:element.description, code: element.code, type: 'CONCIERGE'})}}
                                            elementId={element.id}
                                            type={"CONCIERGE"}  
                                            description={element.description} 
                                            total={element.total} 
                                            old={element.overTime} />)
                                })
                            : <></>}
                            {sideMenu ? 
                                sideMenu.sheds.map((element: any) => {
                                    return(
                                        <ShedMonitor 
                                            selectedIdAndType={{id: selectedOnSideMenu.id, type: selectedOnSideMenu.type}}
                                            onClick={() => {setSelectedOnSideMenu({id: element.id, description:element.description, code: element.code, type: 'SHED'})}}
                                            elementId={element.id}
                                            type={"SHED"}  
                                            description={element.description} 
                                            total={element.total} 
                                            old={element.overTime} />)
                                })
                            : <></>}
                        </Grid>

                        <Grid item xs={9} style={{ width: '100%'}}>
                            <DataGrid 
                                shedId={selectedOnSideMenu.id} 
                                itemCode={selectedOnSideMenu.code}
                                description={selectedOnSideMenu.description} 
                                type={selectedOnSideMenu.type} />
                        </Grid>
                        <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => history.push('/blank')}>{"Fechar"}</Button>
            </DialogActions>
        </Dialog>
    )
}
export default MonitoringPanel;
